import {
  CardContent,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';
import { MultipleChoiceGradingQuestion, SingleChoiceGradingQuestion } from './GradingQuestionType';
import GradingQuestionInput from './GradingQuestionInput';
import { GradingQuestionAction } from './GradingQuestionReducer';

interface MultipleChoiceGradingCardProps {
  data: MultipleChoiceGradingQuestion | SingleChoiceGradingQuestion;
  dispatch: React.Dispatch<GradingQuestionAction>;
  isViewMode?: boolean;
}

const MultipleChoiceGradingCard: React.FC<MultipleChoiceGradingCardProps> = ({
  data,
  dispatch,
  isViewMode = false,
}) => {
  const applicantAnswers = data.answer;
  return (
    <CardContent
      sx={{
        marginTop: '24px',
        marginBottom: '12px',
        marginLeft: '48px',
        marginRight: '48px',
        position: 'relative',
      }}
    >
      <Typography variant="h6" sx={{ textAlign: 'left', fontWeight: 'bold' }}>
        {`Question ${data.questionIndex + 1}`}
      </Typography>
      <Grid>
        <Grid item>
          <Typography
            align="left"
            variant="body1"
            gutterBottom
            sx={{
              width: '80%',
            }}
          >
            {data.text}
          </Typography>
          <Stack direction="column" spacing={1}>
            <RadioGroup>
              {[...data.possibleChoice]
                .sort((a, b) => a.id - b.id)
                .map((choice, i) => {
                const checked = data.answer.includes(choice.id);
                const isCorrect = choice.isCorrect;
                const color = isCorrect
                  ? 'var(--ttg-green)'
                  : checked
                    ? 'var(--red-highlight)'
                    : 'default';
                return (
                  <FormControlLabel
                    key={i}
                    control={<Radio />}
                    checked={checked}
                    label={choice.option}
                    sx={{
                      backgroundColor: color,
                    }}
                  />
                );
              })}
            </RadioGroup>
          </Stack>
        </Grid>
        <GradingQuestionInput
          dispatch={dispatch}
          maxGrade={data.maxGrade}
          grade={data.grade}
          questionIndex={data.questionIndex}
          gradable={!isViewMode}
        />
      </Grid>
    </CardContent>
  );
};

export default MultipleChoiceGradingCard;
